import request from '@/utils/request'

export function profile_update(data) { // 更新个人资料
  return request({
    url: '/api/v2/web/update_student',
    method: 'post',
    data: data
  })
}
export function order_lists(data) { // 我的订单
  return request({
    url: '/api/v2/web/student/order/lists',
    method: 'GET',
    params: data
  })
}
export function email_code(data) { // 邮箱验证
  return request({
    url: '/api/v2/web/mail_code',
    method: 'post',
    data: data
  })
}


export function submit_reject(data) { // 学员提交内容 不同意或者同意
  return request({
    url: '/api/v2/user_processes/processes_info/submit_reject',
    method: 'post',
    params: data
  })
}


export function set_time(data) {
  return request({
    url: '/api/v2/user_processes/processes_info/update_set_time',
    method: 'post',
    params: data
  })
}


export function set_new_time(data) { // 学员提交内容 设置下一次规划时间
  return request({
    url: '/api/v2/user_processes/processes_info/set_new_time',
    method: 'post',
    params: data
  })
}


export function my_info_submit(data) { // 获取待办详情列表及学员提交历史
  return request({
    url: '/api/v2/user_processes/processes_info/my_info_submit',
    method: 'GET',
    params: data
  })
}

export function all_review(data) { // 获取待审核列表及学员提交历史
  return request({
    url: '/api/v2/user_processes/processes_info/all_review',
    method: 'GET',
    params: data
  })
}

export function file_management(data) { // 获取所有最新上传文件
  return request({
    url: '/api/v2/user_processes/processes/file_management',
    method: 'GET',
    params: data
  })
}

export function get_overseas_study(data) { // 获取所有进度和代办页面
  return request({
    url: '/api/v2/user_processes/processes/get_overseas_study',
    method: 'GET',
    params: data
  })
}

export function all_finished(data) { // 获取已完成列表及学员提交历史
  return request({
    url: '/api/v2/user_processes/processes_info/all_finished',
    method: 'GET',
    params: data
  })
}
export function my_overseas_study_web(data) { //获取学员留学进度图
  return request({
    url: '/api/v2/user_processes/processes/my_overseas_study_web',
    method: 'GET',
    params: data
  })
}
export function submit_processes_info_web(data) { //完成待办任务
  return request({
    url: '/api/v2/user_processes/processes_info/submit_processes_info_web',
    method: 'post',
    data: data
  })
}
export function web_show(data) { //获取学员留学进度图
  return request({
    url: '/api/v1/lesson/my_class_mixed/web_show',
    method: 'GET',
    params: data
  })
}
export function had_begin(data) { //正在直播
  return request({
    url: '/api/v1/lesson/my_class_mixed/had_begin',
    method: 'GET',
    params: data
  })
}
export function rtm_token_web(data) { // web端登录
  return request({
    url: '/api/v2/lesson/live/rtm_token_web',
    method: 'get',
    params: data
  })
}
export function get_chooseschool_list(data) { // 获取已完成列表及学员提交历史
  return request({
    url: '/api/v2/choice_school/get_choice_school_list',
    method: 'get',
    data: data
  })
}
export function update_chooseschool(data) { // 修改选校表状态
  return request({
    url: '/api/v2/choice_school/update_choose_school',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/mycenter.js